import { Banner, ImageIcon } from '@farol-ds/react'

import styles from './attachment-image.module.scss'

export const AttachmentImage = () => (
  <Banner type="discovery" className={styles.container}>
    <Banner.Content>
      <Banner.Title>
        <Banner.Icon>
          <ImageIcon />
        </Banner.Icon>
        Imagem não disponível
      </Banner.Title>
      <Banner.Description>
        Essa imagem foi ocultada para preservar a parte do processo.
      </Banner.Description>
    </Banner.Content>
  </Banner>
)
